import { createApiCall } from 'services'

import { call, fork, put, takeLatest } from 'redux-saga/effects'


import { paymentSuccess, paymentFailure } from './actions'
import { PAYMENT_REQUEST, PaymentItem } from './types'
import { storage } from '../../utils'








export function* paymentRequestForItems(): Generator {
  yield takeLatest(PAYMENT_REQUEST, function* (action: { type: typeof PAYMENT_REQUEST; payload: PaymentItem[] }) {
    try {
      const response: any = yield call(createApiCall, {
        method: 'POST',
        url: '/payments/create-payment-intent',
        data: { items: action.payload, company_id: storage.getItem('selectedCompany') },
      })
      
      const {
        data: { data },
        status,
      } = response
      
      if (status === 201 || status === 200) {
        yield put(paymentSuccess(data))
      } else {
        throw new Error(response.data.message);
      }
      // Redirect to a success page or show a success message
    } catch (error: any) {
      yield put(paymentFailure(error.message))
    }
  })
}

export default [fork(paymentRequestForItems)]